import React from 'react'
import Skeleton from "react-loading-skeleton";
import styles from 'components/FoodCourt/FoodCourtCategories.module.css';

function FoodCourtCategoriesSkeleton() {
    return(
        <div className={styles.item_categories} style={{lineHeight: 1}}>
            <Skeleton height={429} width={500}/>
        </div>
    );
}
export default FoodCourtCategoriesSkeleton;